import { cn } from '~/common/utils/styleUtil';
import { LucideCode, LucideX } from 'lucide-react';
import { useLocalStorage, useSessionStorage } from 'usehooks-ts';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '~/common/components/ui/tabs';
import { SessionInformation } from '~/shell/routes/AuthSessionRoute';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TgsDevToolsSettings } from './TgsDevToolsSettings';

export function TgsDevTools() {
  const [showDevTools] = useLocalStorage('showDevTools', process.env.NODE_ENV === 'development');
  const [open, setOpen] = useSessionStorage('tgsDevToolsOpen', false);
  const [activeTab, setActiveTab] = useLocalStorage('tgsDevToolsActiveTab', 'session');

  if (!showDevTools) {
    return null;
  }

  return (
    <>
      <button type="button"
        className={cn(
          'fixed bottom-[10px] left-[10px] text-white z-999 h-[50px] w-[50px] text-xs bg-gray-800 rounded flex items-center justify-center',
          open && 'rounded-t-none'
        )}
        onClick={() => setOpen(prevState => !prevState)}
      >
        {open ? <LucideX /> : <LucideCode />}
      </button>
      {open && (
        <div
          className={
            'flex fixed bottom-[60px] left-[10px] bg-gray-800 text-white p-4 pl-0 rounded-t rounded-br z-998 min-h-[600px] min-w-[800px]'
          }
        >
          <div style={{ writingMode: 'vertical-lr' }} className={'text-base font-bold px-2 rotate-180'}>
            TGS Developer Tools
          </div>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList>
              <TabsTrigger value="session">Session Information</TabsTrigger>
              <TabsTrigger value="settings">Settings</TabsTrigger>
            </TabsList>
            <TabsContent value="session">
              <SessionInformation />
            </TabsContent>
            <TabsContent value="settings">
              <TgsDevToolsSettings />
            </TabsContent>
          </Tabs>
        </div>
      )}
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
}
